import React from 'react';
import {Button, Grid, Input, Modal} from 'semantic-ui-react';
import {socket} from "../../../lib/socketio";
import { useSelector } from 'react-redux';
import {isAuthorized } from '../../../lib/authorization';
import { createUserLog } from '../../../lib/api';

const ControlColumn = ({ index, column, data}) => {

    const [tagdata, settagdata]= React.useState('');
    const [open, setOpen] = React.useState(false);
    const [dataCopy, setDataCopy] = React.useState();
    const [isCopied, setIsCopied] = React.useState(false)
    const [checkdata, setcheckdata]= React.useState('');
    const [isValidationError, setIsValidationError] = React.useState(false);
    const user = useSelector(state => state.nav.user);
    const ppid = useSelector(state => state.header.ppid);
    const electronApp = useSelector(state => state.nav.electronApp);
    const [log, setLog]= React.useState('');

    React.useEffect(() => {
        if(Object.keys(data).length !== 0 && !isCopied){
            setDataCopy({...data});
            setIsCopied(true)
        }
    }, [data]);

    const handleOpen = (event, id) => {
        setOpen({...open, [id]:true});
    };

    const handleClose = (id) => {
        setIsValidationError(false);
        settagdata('');
        setcheckdata('');
        setOpen({...open, [id]:false});
    };

    const handleSubmit = (event, id, min, max) => {
        event.preventDefault();
        if(typeof tagdata === 'undefined' || tagdata === ''){
            setOpen({...open, [id]:false});
        }
        else {
            var writedata = [{'tag_id': id, 'tag_value': tagdata}];
            socket.emit('write tag', writedata);
            setOpen({...open, [id]:false});
            if(!electronApp){
                createUserLog( { log})
                    .catch(console.error)
            }
        }
        settagdata('');
    }


    const handleChange = (event, value, id, min, max, display_id) => {
        event.preventDefault();
        if(event.target.value < min || event.target.value > max){
            setIsValidationError(true);
        }
        else {
            setIsValidationError(false);
            settagdata(event.target.value);
            if(!electronApp){
                setLog({'user_id': user.id, 'powerplant_id': ppid, 'display_id': display_id, 'datetime': new Date().toISOString(), data: JSON.stringify({'tag_id': [id]}) })
            }
        }

      }

    const getValue = (parm,name) => {
        if(parm === 1) {
                return 'Enable'
        }
        else {
                return 'Disable'
        }
    };

    const handleCheck = (event, obj_key, display_id) => {
        if( event.target.id === "1") {
            setcheckdata(1);
            setDataCopy({...dataCopy, [obj_key]: 1});
            if(!electronApp){
                setLog({'user_id': user.id, 'powerplant_id': ppid, 'display_id': display_id, 'datetime': new Date().toISOString(), data: JSON.stringify({'tag_id': [obj_key]}) })
            }
        }
        else if( event.target.id === "0"){
            setcheckdata(0);
            setDataCopy({...dataCopy, [obj_key]: 0});
            if(!electronApp){
                setLog({'user_id': user.id, 'powerplant_id': ppid, 'display_id': display_id, 'datetime': new Date().toISOString(), data: JSON.stringify({'tag_id': [obj_key]}) })
            }
        }
    }

    const handleToggle = (event, id) => {
        event.preventDefault();
        if(typeof checkdata === 'undefined' || checkdata === ''){
            setOpen({...open, [id]:false});
        }
        else {
            var writedata = [{'tag_id': id, 'tag_value': checkdata}];
            socket.emit('write tag', writedata);
            setOpen({...open, [id]: false});
            if (!electronApp) {
                createUserLog({ log }).catch(console.error);
            }
        }
        setcheckdata('');
    }

    const getDecimal = (id) => {
        if(id === 29878 || id === 31285 || id === 32692 || id === 34099 || id === 35506
            || id === 29880 || id === 31287 || id === 32694 || id === 34101 || id === 35508
            || id === 36881 || id === 36882 || id === 36883 || id === 36884 || id === 36885 || id === 36880 ||
            id === 37284 || id === 37285 || id === 37286 || id === 37287 || id === 37288 || id === 37283 ||
            id === 37687 || id === 37688 || id === 37689 || id === 37690 || id === 37691 || id === 37686 ||
            id === 38090 || id === 38091 || id === 38092 || id === 38093 || id === 38094 || id === 38089 ||
            id === 38493 || id === 38494 || id === 38495 || id === 38496 || id === 38497 || id === 38492 ||
            id === 36886 || id === 36887 || id === 36888 || id === 36889 || id === 36890 || id === 36891 ||
            id === 37289 || id === 37290 || id === 37291 || id === 37292 || id === 37293 || id === 37294 ||
            id === 37692 || id === 37693 || id === 37694 || id === 37695 || id === 37696 || id === 37697 ||
            id === 38095 || id === 38096 || id === 38097 || id === 38098 || id === 38099 || id === 38100 ||
            id === 38498 || id === 38499 || id === 38500 || id === 38501 || id === 38502 || id === 38503
         ){ // CL110_KP, CL110_DENSCONST, 
            return '0.000001'; // 6 decimals
        }
        // else if(id === 10338 ){ //CL110_CLOGFACTOR
        //     return '0.0000001'; // 7 decimals
        // }
        else return '0.0001'; // 4 decimals
    }

        return (
        <Grid.Column key={index} style={{ maxWidth: '500px', padding: '10', marginTop: '10px'}}>
            <Grid columns='equal'  style={styles.grid}>
                {column.map(r =>
                    <Grid.Row key={r.id} style={styles.row}>
                        <Grid.Column width='10' style={styles.name}>{(r.tag_display_name !== null) ? r.tag_display_name : r.name}</Grid.Column>
                        {/* PAFC Code
                            { r.id === 13229 ?
                            ''
                            :
                            <Grid.Column width='10' style={styles.name}>{(r.tag_display_name !== null) ? r.tag_display_name : r.name}</Grid.Column>
                        } */}

                        <Grid.Column style={{color: '#04BFBF', fontWeight: 'bold'}}>
                            {   
                                // r.id === 13229 ?
                                // ''
                                // :
                                r.canHMIWrite === 0 || r.name.slice(5,8) === 'CP_' ?
                                <>
                                    <Button
                                        key='button'
                                        disabled
                                        content={data[r.id]}/>
                                    <Modal></Modal>{r.unit}
                                </>
                                : r.id === 9999 || r.name.slice(5,9) === 'OPT_'? // 5714 : CL110_PIRESET
                                <>
                                    <Button
                                        key = 'button'
                                        size='tiny'
                                        disabled={electronApp ? false : !isAuthorized(user.hmi_role, r.hmi_security)}
                                        content = {getValue(data[r.id])}
                                        inverted color = {data[r.id] === 1 ? 'green' : 'yellow'}
                                        onClick ={  () => {setOpen({...open, [r.id]:true})}}/>
                                    <Modal
                                        key = {r.id}
                                        style = {styles.width}
                                        open = {open[r.id]}
                                        onClose={handleClose[r.id]}
                                        onOpen = {handleOpen[r.id]}>
                                        <Modal.Header>Select Choice for {r.tag_display_name} </Modal.Header>
                                        <Modal.Content>
                                            <Input
                                                type='radio'
                                                id={1}
                                                label='Enable'
                                                checked={typeof dataCopy !== 'undefined' ? dataCopy[r.id] === 1 : ''}
                                                onChange={(event, value) => handleCheck(event,r.id,r.display_id)}
                                                style={styles.checkbox1}
                                                />
                                            <Input
                                                type='radio'
                                                id={0}
                                                label='Disable'
                                                checked={typeof dataCopy !== 'undefined' ? dataCopy[r.id] === 0 : ''}
                                                onChange={(event, value) => handleCheck(event,r.id,r.display_id)}
                                                style={styles.checkbox1}
                                                />
                                        </Modal.Content>
                                        <Modal.Actions style={styles.toggle}>
                                            <Button color='blue' content={'Ok'}
                                                onClick={(event, value) => handleToggle(event,r.id)}/>
                                            <Button color='red' content={'Cancel'}
                                                onClick={  () => handleClose(r.id)}/>
                                        </Modal.Actions>
                                    </Modal>
                                </>
                                :
                                <>
                                    <Button
                                        key = 'button'
                                        type = 'button'
                                        size='tiny'
                                        disabled={electronApp ? false : !isAuthorized(user.hmi_role, r.hmi_security)}
                                        content = {data[r.id]}
                                        onClick ={  () => {setOpen({...open, [r.id]:true})}}/>
                                    <Modal
                                        key = {r.id}
                                        style = {styles.width}
                                        open = {open[r.id]}
                                        onClose={handleClose[r.id]}
                                        onOpen={handleOpen[r.id]}>
                                        <Modal.Header>Enter Value for {r.name}</Modal.Header>
                                        <Modal.Content>
                                            <form  style = {styles.form} autoComplete='off' onSubmit={(event, value) => handleSubmit(event, r.id, r.min, r.max)}>
                                                <Input focus placeholder='Value'
                                                       name='Input change'
                                                       label = {r.unit || ""}
                                                       labelPosition='right'
                                                       type='number'
                                                       step ={getDecimal(r.id)}
                                                       size='small'
                                                       autoFocus
                                                       min ={r.min}
                                                       max ={r.max}
                                                       error={isValidationError}
                                                       onChange={(event, value) => handleChange(event, value, r.id, r.min, r.max, r.display_id)}
                                                       defaultValue={data[r.id]}
                                                />
                                              </form>
                                        </Modal.Content>
                                        <Modal.Actions>
                                            <Button color='blue' content={'Ok'} disabled={isValidationError} onClick={(event, value) => handleSubmit(event, r.id, r.min, r.max)}/>
                                            <Button
                                                key = 'button'
                                                content = 'Close'
                                                color = 'red'
                                                style={{marginLeft: '5px', marginTop: '10px'}}
                                                onClick ={  () => handleClose(r.id)}/>
                                        </Modal.Actions>
                                    </Modal> {r.unit}
                                </>
                            }
                        </Grid.Column>
                    </Grid.Row>
                )}
            </Grid>
        </Grid.Column>
    );
};


const styles = {
    grid: {
        // margin: '0',
        paddingBottom: '0'
    },
    width: {
        maxWidth: '400px'
    },
    name: {
        color: 'yellow',
        // fontWeight: 'bold'
    },
    form: {
        padding: '10px'
    },
    row: {
        // paddingBottom: '0'
        padding: '2px 0'
    },
    checkbox1: {
        flexDirection: 'row-reverse',
    }
};

export default React.memo(ControlColumn);

